// extracted by mini-css-extract-plugin
export default {"wrapper":"AddJiraConnectionForm_wrapper__IF1On","controlWrapper":"AddJiraConnectionForm_controlWrapper__tTqB1"};